module.exports = __webpack_public_path__ + "static/item--plant@3x.65645c5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--plant@3x.png
// module id = 655
// module chunks = 126511778744290